<script setup lang="ts">
import type { AgentOnPage } from '@@/shared/agent/api-types';

const props = defineProps<{
  agent?: AgentOnPage
}>();

const { locale } = useI18n();
const propertipsLanguage = computed(() => locale.value === `fr` ? `fr_FR` : `en_EN`);
const propertipsLink = computed(() => {
  const propertipsUrl = new URL(`https://www.propertips.com`);
  propertipsUrl.searchParams.append(`lang`, propertipsLanguage.value);
  return propertipsUrl.toString();
});
const propertipsMaybeAgentHref = computed(() => {
  if (!props.agent) return propertipsLink.value;
  // We don't want `/` to be encoded
  // ⇒ do not use URL constructor
  return `https://www.propertips.com/?${props.agent.agentId}/${propertipsLanguage.value}`;
});
</script>

<template>
  <IadWrapper
    class="sm:rounded-2xl"
    :padded="false"
  >
    <div class="bg-secondary-40 text-white md:rounded-2xl p-m">
      <figure class="pb-m text-center">
        <img
          class="h-10 inline-block"
          loading="lazy"
          alt="Propertips logo"
          width="135"
          height="40"
          src="~/assets/images/propertips.svg"
        >
      </figure>
      <div class="flex flex-col gap-xs md:gap-m">
        <div class="md:text-center">
          <IadTitle
            tag="p"
            variant="small-semibold"
            :text="$t(`property.propertips.question`)"
          />
          <IadTitle
            tag="p"
            class="pt-2xs md:pt-m"
            variant="small"
            :text="$t(`property.propertips.answer`)"
          />
        </div>
        <IadBtn
          class="self-center"
          size="large"
          target="_blank"
          :href="propertipsMaybeAgentHref"
          :text="$t(`core.common.to-know-more`)"
        />
        <I18nT
          keypath="property.propertips.required"
          class="text-xs self-start"
          tag="p"
        >
          <template #propertips>
            <a
              class="lowercase underline"
              :href="propertipsLink"
              target="_blank"
              v-text="'propertips.com'"
            />
          </template>
        </I18nT>
      </div>
    </div>
  </IadWrapper>
</template>
